<template>
  <div>
    <div
      class="boss-accordion-table-head pega-input"
      @click.self="$emit('on-accordion-switch', !isOpened)"
    >
      <label class="pega-input">
        <input
          :value="isOpened"
          :checked="isOpened"
          type="checkbox"
          class="boss-input-checkbox"
          @change="onAccordionSwitch"
        >
        {{ title }}
      </label>
      <span
        v-if="label != ''"
        class="boss-notice-label"
      >{{ label }}</span>
    </div>
    <div
      v-show="isOpened"
      class="boss-accordion-table-body"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'タイトル'
    },
    isOpened: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  methods: {
    onAccordionSwitch (val) {
      this.$emit('on-accordion-switch', val.target.checked)
    }
  }
}
</script>
